import React from 'react';

export default function NotFound() {
  return (
    <h2>404 - Not Found</h2>
  );
}